import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styles from "./OlympiadJane.module.scss";
import Image from "next/image";
import JanePortrait from "@cs/public/img/olympiad/jane-goodall.png"
import Balancer from "react-wrap-balancer";

const OlympiadJane: FC = () => {
  const { t } = useTranslation(["olympiad"]);

  return (
    <section className={styles.secWrapper}>
      <figure className={styles.bg}>
        <Image
          src="/img/olympiad/jane-presentation.png"
          alt={t("jane-img")}
          layout="responsive"
          width={1446}
          height={691}
        />
        <h2 className={styles.h2}>
          <Balancer>
            <Trans
              t={t}
              i18nKey={t("jane-title")}
            />
          </Balancer>
        </h2>
        <p className={styles.imgOverlayDesc}>
          {t("jane-img")}
        </p>
      </figure>
      <div className={styles.quote}>
        <figure>
          <Image
            src={JanePortrait}
            alt="Jane Goodall"
          />
        </figure>
        <article>
          <p className={styles.italic}>
            <i>{t("jane-quote-1")}</i>
          </p>
          <p className={styles.strong}>
            <strong>{t("jane-quote-2")}</strong>
          </p>
        </article>
      </div>
    </section>
  );
};

export default OlympiadJane;
